import React from 'react';
import { ArrowRight, Search, FileText, BarChart3 } from 'lucide-react';
import { LogIn } from 'lucide-react';

const GITHUB_ASSETS_BASE = 'https://raw.githubusercontent.com/Muna-Lombe/loghog_public_content/main/.github/images';

const LandingPage = ({ onGetStarted, onLogin }) => {
  return (
    <div className="landing-page">
      {/* Navigation */}
      <nav className="landing-nav">
        <div className="landing-container">
          <div className="nav-content">
            <div className="nav-logo">
              <img src="/logo.ico" alt="LogHog" className="nav-logo-icon" />
              <span className="nav-logo-text">LogHog</span>
            </div>
            <div className="nav-links">
              <a href="#features">Features</a>
              <a href="#how-it-works">How It Works</a>
              <a href="#insights">Insights</a>
              <button className="btn-cta btn-text" onClick={onGetStarted}>
                <span className="">Get Started Free</span>
              </button>
              <button className="btn btn-outline" onClick={onLogin}>
                <span className="btn-text">Log In</span>
                <LogIn className="" size={18} />
              </button>
              
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="landing-container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Monitor, Log & Master Your APIs
              </h1>
              <p className="hero-subtitle">
                Seamless API Observability for Developers
              </p>
              <div className="hero-buttons">
                <button className="btn-cta-large" onClick={onGetStarted}>
                  Start Monitoring
                </button>
                <button className="btn-outline-large">
                  Book a Demo
                </button>
              </div>
            </div>
            <div className="hero-image">
              <img 
                src={`${GITHUB_ASSETS_BASE}/loghog_hero_section.png`}
                alt="LogHog Dashboard"
                className="hero-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works-section">
        <div className="landing-container">
          <h2 className="section-title">How It Works</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <img 
                  src={`${GITHUB_ASSETS_BASE}/loghog_how_it_works_section_observe_icon.png`}
                  alt="Observe"
                />
              </div>
              <h3>Observe</h3>
              <p>Seamlessly streamlined info to audit and structured.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <img 
                  src={`${GITHUB_ASSETS_BASE}/loghog_how_it_works_section_log_icon.png`}
                  alt="Log"
                />
              </div>
              <h3>Log</h3>
              <p>Bearinae trenoit's tionroreofsevet strott tiay.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <img 
                  src={`${GITHUB_ASSETS_BASE}/loghog_how_it_works_section_analyze_icon.png`}
                  alt="Analyze"
                />
              </div>
              <h3>Analyze</h3>
              <p>See nenia tetate benv viewing oval anno en mon talare.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Real-time Insights Section */}
      <section id="insights" className="insights-section">
        <div className="landing-container">
          <div className="insights-content">
            <div className="insights-text">
              <h2 className="section-title-white">Real-time Insights</h2>
              <div className="testimonial">
                <img 
                  src={`${GITHUB_ASSETS_BASE}/loghog_realtime_insights_testimonial_avatar.png`}
                  alt="Developer"
                  className="testimonial-avatar"
                />
                <blockquote>
                  "LogHog content hoonit eent of cloaelyet morooiVansheme 
                  trot espina teste midol thel nad nep excrem."
                </blockquote>
              </div>
            </div>
            <div className="insights-image">
              <img 
                src={`${GITHUB_ASSETS_BASE}/loghog_realtime_insights_dashboard_screenshot.png`}
                alt="Dashboard Screenshot"
                className="dashboard-screenshot"
              />
            </div>
          </div>
          
          <div className="cta-section">
            <h2 className="cta-title">Ready to Tame Your APIs?</h2>
            <button className="btn-cta-large" onClick={onGetStarted}>
              Get Started Free
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="landing-container">
          <div className="footer-content">
            <p>&copy; {new Date().getFullYear()} LogHog. All rights reserved.</p>
            <div className="footer-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
              <a href="#">Contact</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;

